import type { TPostTableRowProps } from './TableRow.types';

export const PostTableRow = (props: TPostTableRowProps) => {
  const { children } = props;

  return <tr>{children}</tr>;
};
